export default __webpack_public_path__ + "static/media/cloud2.40de1ced.svg";